export const meaningfulProps = [
  'match.path',
  'experience',
  'similarExperiences',
  'market',
  'kioskHomeUrl',
  'activeMarketExperiences',
  'activeMarket',
  'showPolicy',
  'currentExperienceHomeRoute',
];
